export default __webpack_public_path__ + "static/media/newsimg.3b51cfcc.png";